export default __webpack_public_path__ + "static/media/SafeLogo.7ab12508.png";